import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { usePanelState } from "../../../../../stores/hooks/usePanelState";
import { Checkbox } from "../../../../../ui/Checkbox/Checkbox";
import { Collapsible } from "../../../../../ui/CollapsiblePannel/Collapsible";
import { useTireLoadRating } from "./useTireLoadRating";
import { useTireLoadRatingOptions } from "./useTireLoadRatingOptions";

const id = "dealer-tire-load-rating-panel";

export const TireLoadRaitingFilters: FunctionComponent = () => {
  const [panelIsOpen, togglePanel] = usePanelState(id, false);
  const { t } = useTranslation();
  const [, { toggle }] = useTireLoadRating();
  const options = useTireLoadRatingOptions();

  return (
    <Collapsible
      className=" space-y-2"
      id={id}
      label={t("searchResults.tireLoadRating")}
      onToggle={togglePanel}
      visible={panelIsOpen}
    >
      {options.map(({ checked, count, tireLoadRating }) => (
        <label
          className={clsx("flex gap-x-4", !count && "opacity-40")}
          key={tireLoadRating}
        >
          <Checkbox
            onChange={(): void => {
              toggle([tireLoadRating]);
            }}
            checked={checked}
            checkedClassName="text-selected-tab"
            disabled={count === 0}
            name="tireLoadRating"
          />
          <span className="flex-1">{tireLoadRating}</span>
        </label>
      ))}
    </Collapsible>
  );
};
